/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import { getProxyUrl } from '../../utils/image';
import {
  hasPlayerScored,
  hasPlayerBeenSubstituted,
  hasPlayerWarning,
} from '../../utils/matchevents';
import { getPlayerUrlById } from '../../utils/routes';

function Formation({ match, homeTeam }) {
  const lineup = homeTeam ? match?.homeTeamLineup : match?.visitingTeamLineup;
  const team = homeTeam ? match?.homeTeamName : match?.visitingTeamName;
  const teamAbbrv = homeTeam ? match?.homeTeamAbbrv : match?.visitingTeamAbbrv;

  const renderFormationPlayer = (player) => {
    const showGoalIcon = hasPlayerScored(player, match?.matchEvents);
    const showSubIcon = hasPlayerBeenSubstituted(player, match?.matchEvents);
    const showWarningIcon = hasPlayerWarning(player, match?.matchEvents);
    const playerUrl = getPlayerUrlById(player?.fogisId);
    return (
      <div className={`match-formation__item ${homeTeam ? '' : 'flipped'}`}>
        <div className="player-bust">
          <div className="player-bust__images player-bust__images--formation">
            <img
              className="player-bust__player-image"
              src={getProxyUrl(player?.imageHalf200, 200, 200)}
              alt=""
            />
          </div>
          <a
              style={{ pointerEvents: playerUrl ? 'auto' : 'none' }}
              href={playerUrl ? playerUrl : ''}
            className="player-bust__info player-bust__info--formation text-decoration-none"
          >
            <div className="player-bust__number player-bust__number--formation fw-bold">
              {player?.number}
            </div>
            <div className="player-bust__name player-bust__name--formation d-flex flex-column justify-content-center">
              <div className="text-tiny fw-bold text-transform-none d-none d-lg-block">
                {player?.givenName}
              </div>
              <div className="text-tiny-extra text-lg-small text-transform-none d-flex fw-bold">
                <span className="d-inline-block d-lg-none me-1">
                  {player?.givenName[0]}.
                </span>
                {player?.surName}
              </div>
            </div>
            <div className="player-bust__events">
              {showSubIcon && (
                <div className="d-flex flex-column">
                  <svg
                    className="arrow--left arrow--red"
                    width="8"
                    height="8"
                    viewBox="0 0 11 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.0156919 5.60568L5.50785 0.461426L11 5.60568L9.71327 6.81693L6.41797 3.73892L6.41797 12.4614H4.58202L4.58203 3.72468L1.28673 6.80268L0 5.59142L0.0156919 5.60568Z"
                      fill="currentColor"
                    />
                  </svg>
                  <svg
                    className="arrow--right arrow--green"
                    width="8"
                    height="8"
                    viewBox="0 0 11 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.0156919 5.60568L5.50785 0.461426L11 5.60568L9.71327 6.81693L6.41797 3.73892L6.41797 12.4614H4.58202L4.58203 3.72468L1.28673 6.80268L0 5.59142L0.0156919 5.60568Z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
              )}
              {showGoalIcon &&
                showGoalIcon.map(() => (
                    <object width="17" height="17" data="/wp-content/themes/sef-leagues/images/football-logo.svg" type="image/svg+xml"></object>
                ))}
              {showWarningIcon && <div className="yellow-card" />}
            </div>
          </a>
        </div>
      </div>
    );
  };
  const renderSubPlayer = (player) => {
    const showGoalIcon = hasPlayerScored(player, match?.matchEvents);
    const showSubIcon = hasPlayerBeenSubstituted(player, match?.matchEvents);
    const showWarningIcon = hasPlayerWarning(player, match?.matchEvents);
    const playerUrl = getPlayerUrlById(player?.fogisId);

    return (
      <div className="data-container__row px-4 py-1 d-flex align-items-center">
        <a
            style={{ pointerEvents: playerUrl ? 'auto' : 'none' }}
            href={playerUrl ? playerUrl : ''}
          className="d-flex align-items-center text-decoration-none text-color-primary-white"
        >
          <div className="player-bust__number player-bust__number--lineup fw-bold">
            {player?.number}
          </div>
          <div className="player-bust__name player-bust__name--lineup d-flex fw-bold">
            {`${player?.givenName} ${player?.surName}`}
          </div>
        </a>
        <div className="d-flex gap-2 ms-auto align-items-center">
          {showSubIcon && (
            <div className="d-flex flex-column">
              <svg
                className="arrow--left arrow--red"
                width="11"
                height="13"
                viewBox="0 0 11 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.0156919 5.60568L5.50785 0.461426L11 5.60568L9.71327 6.81693L6.41797 3.73892L6.41797 12.4614H4.58202L4.58203 3.72468L1.28673 6.80268L0 5.59142L0.0156919 5.60568Z"
                  fill="currentColor"
                />
              </svg>
              <svg
                className="arrow--right arrow--green"
                width="11"
                height="13"
                viewBox="0 0 11 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.0156919 5.60568L5.50785 0.461426L11 5.60568L9.71327 6.81693L6.41797 3.73892L6.41797 12.4614H4.58202L4.58203 3.72468L1.28673 6.80268L0 5.59142L0.0156919 5.60568Z"
                  fill="currentColor"
                />
              </svg>
            </div>
          )}
          {showGoalIcon &&
            showGoalIcon.map(() => (
                <object width="17" height="17" data="/wp-content/themes/sef-leagues/images/football-logo.svg" type="image/svg+xml"></object>
            ))}
          {showWarningIcon && <div className="yellow-card" />}
        </div>
      </div>
    );
  };

  return (
      <section className="row mt-5">
        <div className="col-12 col-lg-7">
          <h3 className="heading-h3 d-none d-lg-block">STARTELVA - {team}</h3>
          <p className="text-small fw-bold text-color-primary-yellow">
            {lineup?.formation}
          </p>
          <div
              className={`match-formation match-formation--formation-${lineup?.formation} ${homeTeam ? '' : 'flipped'}`}
          >
            {lineup?.starting.map((p) => renderFormationPlayer(p))}
          </div>
        </div>
        <div className="col-12 col-lg mt-4 mt-lg-0">
          <div className="data-container">
            <div className="data-container__row data-container__header px-4 py-3">
              <span className="heading-h5 text-transform-none">Ersättare</span>
            </div>
            {lineup?.substitutes.map((p) => renderSubPlayer(p))}
          </div>
        </div>
      </section>
  );
}

export default Formation;
